// 资讯
import base from '../base'
import { request } from '../http'

export default {
  getInformation: promise => request('get', `${base.api.url}/index.php/wp-json/wp/v2/posts`, promise)

}
